var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ecb3a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico Linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,0C7.41,0,8.8,0,10.19,0a1.7,1.7,0,0,1,1.54.75A1.49,1.49,0,0,1,12,1.6Q12,6,12,10.37A1.62,1.62,0,0,1,10.35,12H2.2a5.46,5.46,0,0,1-1-.06A1.57,1.57,0,0,1,0,10.55c0-.45,0-.9,0-1.35Q0,7.39,0,5.57T0,2a2.54,2.54,0,0,1,.08-.84A1.61,1.61,0,0,1,1.58,0H6ZM6,11.08h4.38a.68.68,0,0,0,.7-.7q0-4.37,0-8.73a.68.68,0,0,0-.73-.72H1.67a.69.69,0,0,0-.74.74q0,4.33,0,8.66a.69.69,0,0,0,.74.75H6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.62,10.15V4.62H6.46v.79l0,0a1.43,1.43,0,0,1,1.15-.75,2.63,2.63,0,0,1,1.42.17A1.65,1.65,0,0,1,10,5.93a4.8,4.8,0,0,1,.17,1.36c0,.92,0,1.84,0,2.76,0,0,0,.06,0,.09H8.31c0-.24,0-.48,0-.72,0-.75,0-1.51,0-2.26a1.69,1.69,0,0,0-.08-.46.64.64,0,0,0-.47-.45,1,1,0,0,0-1.06.28,1.29,1.29,0,0,0-.21.77c0,.55,0,1.09,0,1.64,0,.39,0,.79,0,1.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.86,
    y: 4.63,
    width: 1.83,
    height: 5.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.85,2.77a.92.92,0,0,1,1.84,0,.92.92,0,1,1-1.84,0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLn);
export default __webpack_public_path__ + "static/media/ico-ln.87ca3991a4839582510ab635934b9b90.svg";
export { ForwardRef as ReactComponent };